import React from 'react';
import { Drawer, DrawerBody } from '@paretogroup/tess';
import { NO_TRANSLATE_CLASSNAME } from '@shared/components/no-translate/translation.constants';

import { drawerBodyStyles } from './filter-drawer.styles';
import { CAMPAIGNS_FILTER_AUTO_TEST_IDS, CAMPAIGNS_FILTER_TEST_IDS } from '../campaigns-filter.constants';
import { SaveModal } from '../save-modal/save-modal';
import { FilterDrawerRulesSection } from './filter-drawer-rules-section';
import { FilterDrawerHeader } from './filter-drawer-header';
import { FilterDrawerFooter } from './filter-drawer-footer';
import { FilterDrawerOperations } from './filter-drawer-operations';

export interface DrawerProps {
    onClose: (bool: boolean) => void;
    open: boolean;
}

export const FilterDrawer = ({
    onClose,
    open,
}: DrawerProps) => (
    <Drawer
        open={open}
        onClose={onClose}
        data-testid={CAMPAIGNS_FILTER_TEST_IDS.DRAWER}
        data-auto-testid={CAMPAIGNS_FILTER_AUTO_TEST_IDS.DRAWER}
        className={NO_TRANSLATE_CLASSNAME}
    >
        <FilterDrawerHeader />
        <DrawerBody style={drawerBodyStyles}>
            <FilterDrawerOperations />
            <FilterDrawerRulesSection />
            <FilterDrawerFooter />
        </DrawerBody>
        <SaveModal />
    </Drawer>
);
